import type { JsonValue, ProjectDocument } from "@hyperframes/react/browser";

const CATALOG_IMAGE = /^\/assets\/catalog\/([^/?#]+)\.(?:png|jpe?g|webp)$/i;
const LIVE_PREVIEW_SCALE = 1 / 3;

export function previewImageUrl(image: string): string {
  const match = image.match(CATALOG_IMAGE);
  return match ? `/assets/catalog-preview/${match[1]}.webp` : image;
}

export function createPreviewProject(project: ProjectDocument): ProjectDocument {
  const preview = structuredClone(project);
  preview.format = {
    ...preview.format,
    width: Math.max(1, Math.round(preview.format.width * LIVE_PREVIEW_SCALE)),
    height: Math.max(1, Math.round(preview.format.height * LIVE_PREVIEW_SCALE)),
  };
  for (const scene of preview.scenes) {
    if (!scene.content || typeof scene.content !== "object" || Array.isArray(scene.content)) continue;
    const content = scene.content as Record<string, JsonValue>;
    if (!Array.isArray(content.cards)) continue;
    content.cards = content.cards.map((card) => {
      if (!card || typeof card !== "object" || Array.isArray(card)) return card;
      const record = card as Record<string, JsonValue>;
      return typeof record.image === "string" ? { ...record, image: previewImageUrl(record.image) } : card;
    });
  }
  return preview;
}
